module.exports = __webpack_public_path__ + "static/img/img_banner_a.2b573c09.png";